module.exports = __webpack_public_path__ + "img/ico-facebook-circle.8e3c9132.png";